import React from "react"

const successMessage = () => (
  <p className="text-success text-center text-xsmall">Thanks for subscribing!</p>
)

export default successMessage
